import * as rax from "retry-axios";
import axios, { AxiosRequestConfig } from "axios";
import { IAuthToken } from "../interfaces/IAuthResponse";

rax.attach();

const retryCodes = [[100, 199], [408, 408], [429, 429], [501, 599]];
const raxConfig = {
    statusCodesToRetry: retryCodes,
};

export const checkCookiesEnabled = (): boolean => {
    try {
        document.cookie = "cookietest=1";
        const ret = document.cookie.indexOf('cookietest=') !== -1;
        document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return ret;
    }
    catch (e) {
        return false;
    }
}

export class ApiService {
    private static sessionId: string;

    private static configureConfig(config?: AxiosRequestConfig): AxiosRequestConfig | undefined {
        const retryConfig: AxiosRequestConfig = {
            ...(config ?? {}),
            withCredentials: true,
            raxConfig
        };

        const isCookiesEnabled: boolean = checkCookiesEnabled();

        if (!isCookiesEnabled && this.sessionId) {
            retryConfig.params = {
                sid: this.sessionId
            }
        }

        return retryConfig;
    }

    static setAuthToken(token: IAuthToken): void {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token.jwt}`;
        this.sessionId = token.sessionId;
    }

    static async retryGet(
        url: string,
        config?: AxiosRequestConfig
    ) {
        return await axios.get(url, this.configureConfig(config));
    }

    static async retryPost(
        url: string,
        data: any = null,
        config?: AxiosRequestConfig
    ) {
        return await axios.post(url, data, this.configureConfig(config));
    }

    static async retryPut(url: string, data: any = null, config?: AxiosRequestConfig) {
        return await axios.put(url, data, this.configureConfig(config));
    }

    static async retryDelete(url: string) {
        return await axios.delete(url, this.configureConfig());
    }

    static async axiosRetryPatch(url: string, data: any = null, config?: AxiosRequestConfig) {
        return await axios.patch(url, data, this.configureConfig(config));
    }
}